import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { create_new_mobile_campaign, delete_mobile_campaign, fetch_all_contact_groups, fetch_all_mobile_campaigns, fetch_contact_group_by_id, fetch_mobile_campaign_by_id, update_mobile_campaign_by_mobile_campaign_id } from "../../api/campaignsAPI";
import notify from "../../utils/IANotification";
import { captialise_first_letter, tidy_date } from "../../utils/helper";
import { MdAdd, MdCheck } from "react-icons/md";
import DataTable from "../../components/ui/DataTable";
import Switch from 'react-switch'
import Select from 'react-select'
import StudioEditor from '@grapesjs/studio-sdk/react';
import { rteTinyMce } from '@grapesjs/studio-sdk-plugins';
import '@grapesjs/studio-sdk/style';

export default function CampaignEmailFormPage() {
  const navigate = useNavigate();
  let user_data = useFetchUserData();
  let campaign_id = new URLSearchParams(window.location.search).get("campaign_id");
  const [campaignData, setCampaignData] = useState({
    title: "",
    description: "",
    scheduled_datetime: "",
    status: "",
    is_everyone: 0,
    group_ids: [],
  })
  const [loading, setLoading] = useState(true)
  const [groupData, setGroupData] = useState([])

  const fetchCampaignGroupById = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_contact_groups()
    if (error) notify({ message: message || error, type: 'error' })
    setGroupData(data)
    setLoading(false)
  }

  useEffect(() => {
    fetchCampaignById()
    fetchCampaignGroupById()
  }, [])

  const fetchCampaignById = async () => {
    if (!campaign_id || campaign_id === "new") return
    setLoading(true)
    const { data, error, message, status } = await fetch_mobile_campaign_by_id(campaign_id)
    if (error) notify({ message: message || error, type: 'error' })
    setCampaignData(data)
    setLoading(false)
  }

  const createNewCampaign = async () => {
    const { data, error, message, status } = await create_new_mobile_campaign(campaignData)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign created successfully", type: 'success' })
    navigate(`/admin/campaigns/email/details?campaign_id=${data.id}`)
  }

  const updateCampaignById = async () => {
    if (!campaign_id) return
    const { data, error, message, status } = await update_mobile_campaign_by_mobile_campaign_id(campaign_id, campaignData)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign updated successfully", type: 'success' })
    fetchCampaignById()
  }

  const deleteCampaignById = async () => {
    if (!campaign_id) return
    const { data, error, message, status } = await delete_mobile_campaign(campaign_id)
    if (error) notify({ message: message || error, type: 'error' })
    notify({ message: "Campaign deleted successfully", type: 'success' })
    navigate(`/admin/campaigns/email`)
  }

  const selectOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'scheduled', label: 'Schedule' },
  ]

  return (
    <AdminLayout navSelected={"Email Campaigns"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Email Campaign Details</h1>
          <div className='flex gap-2'>
            {campaign_id !== "new" && (
              <button
                className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
                onClick={deleteCampaignById}
              >
                Delete
              </button>
            )}
            <button
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
              onClick={() => {
                if (campaign_id === "new") {
                  createNewCampaign()
                } else {
                  updateCampaignById()
                }
              }}
            >
              {campaign_id === "new" ? "Create" : "Save"}
            </button>
          </div>
        </>
      }

    >
      {/* <div className="w-full">
        <div className="card mb-2">
          <p className="card-title">Campaign Details</p>
          <div className="input-container">
            <label htmlFor="title" className="input-label">Title</label>
            <input type="text" id="title" className="text-input"
              value={campaignData.title}
              onChange={(e) => setCampaignData({ ...campaignData, title: e.target.value })}
              placeholder="e.g. Welcome to Bedok Methodist Church"
            />
          </div>
          <div className="input-container">
            <label htmlFor="description" className="input-label">Description</label>
            <textarea id="description" className="textarea-input"
              value={campaignData.description}
              onChange={(e) => setCampaignData({ ...campaignData, description: e.target.value })}
              placeholder="e.g. This is a description for the campaign"
            />
          </div>

        </div>
        <div className="card mb-2">
          <p className="card-title">Schedule</p>
          <div className="input-container">
            <label htmlFor="scheduled_datetime" className="input-label">Scheduled Date & Time</label>
            <input type="datetime-local" id="scheduled_datetime" className="text-input" value={campaignData.scheduled_datetime} onChange={(e) => setCampaignData({ ...campaignData, scheduled_datetime: e.target.value })} />
          </div>
          <div className="input-container">
            <label htmlFor="status" className="input-label">Status</label>
            <Select
              id="status"
              className="react-select"
              options={selectOptions}
              value={selectOptions.find(option => option.value === campaignData.status)}
              onChange={(selectedOption) => setCampaignData({ ...campaignData, status: selectedOption.value })}
            />
          </div>
          <div className="flex flex-row items-center py-2 gap-2">
            <Switch
              label="Broadcast"
              checked={campaignData.is_everyone}
              onChange={(checked) => setCampaignData({ ...campaignData, is_everyone: checked ? 1 : 0 })}
            />
            <label htmlFor="" className="input-label">Broadcast</label>
          </div>
          {campaignData?.is_everyone == 0 && <div className="input-container">
            <label htmlFor="description" className="input-label">Groups</label>
            <div className="flex flex-row items-center gap-2">
              <Select
                options={groupData.map(group => ({ value: group.id, label: group.name }))}
                isMulti
                styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                onChange={(selected) => setCampaignData({ ...campaignData, group_ids: selected.map(s => s.value) })}
                value={groupData.filter(group => campaignData.group_ids.includes(group.id)).map(group => ({ value: group.id, label: group.name }))}
              />
            </div>
          </div>}
        </div>
      </div> */}
      {/* <div className="flex flex-row gap-2 justify-end">
        {campaign_id !== "new" && <button className="button-delete" onClick={deleteCampaignById}>Delete</button>}
        <button className="button" onClick={() => {
          if (campaign_id === "new") {
            createNewCampaign()
          } else {
            updateCampaignById()
          }
        }}>Save</button>
      </div> */}
      <StudioEditor
        style={{
          width: "100%",
          height: "80dvh"
        }}
        options={{
          licenseKey: '63c48a0b499a4583a76da871683f4dfc199ebd76c6be44b9bac834ed4bb624af',
          theme: 'light',
          customTheme: {},
          project: {
            type: 'email'
          },
          assets: {
            storageType: 'self',
            // Provide a custom upload handler for assets
            onUpload: async ({ files }) => {
              const body = new FormData();
              for (const file of files) {
                body.append('files', file);
              }
              const response = await fetch('ASSETS_UPLOAD_URL', { method: 'POST', body });
              const result = await response.json();
              // The expected result should be an array of assets, eg.
              // [{ src: 'ASSET_URL' }]
              return result;
            },
            // Provide a custom handler for deleting assets
            onDelete: async ({ assets }) => {
              const body = JSON.stringify(assets);
              await fetch('ASSETS_DELETE_URL', { method: 'DELETE', body });
            }
          },
          storage: {
            type: 'self',
            // Provide a custom handler for saving the project data.
            onSave: async ({ project }) => {
              throw new Error('Implement your "onSave"!');
              const body = new FormData();
              body.append('project', JSON.stringify(project));
              await fetch('PROJECT_SAVE_URL', { method: 'POST', body });
            },
            // Provide a custom handler for loading project data.
            onLoad: async () => {
              throw new Error('Implement your "onLoad"!');
              const response = await fetch('PROJECT_LOAD_URL');
              const project = await response.json();
              // The project JSON is expected to be returned inside an object.
              return { project };
            },
            autosaveChanges: 100,
            autosaveIntervalMs: 10000
          },
          plugins: [
            rteTinyMce.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/rte/tinymce */ })
          ]
        }}
      />
    </AdminLayout>
  )
}